import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { X } from 'lucide-react';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import SvgIcon from '../../components/SvgIcon';

export default function CardModal({
  className,
  title,
  icon,
  children,
  to,
  onOpen,
  isOpen,
  onClose,
  locales: { canvas },
  isPreview = false,
  titleStyle,
  buttonStyle,
  iconStyle,
  iconFill,
  iconFillClose,
  backgroundIcon,
  backgroundBMC,
  firstSvgColor,
  secondSvgColor,
  titleColor,
  backgroundButton,
  isColourfulfunTemplate = false,
  disabled = false,
}) {
  const history = useHistory();

  useEffect(() => {
    onOpen();
  }, []);

  useEffect(() => {
    if (isPreview && !disabled) {
      const body = document.querySelector('body');

      if (isOpen) body.classList.add('body-modal-open');
      else body.classList.remove('body-modal-open');

      return () => {
        body.classList.remove('body-modal-open');
      };
    }
  }, [isOpen]);

  return (
    <Modal
      className={classNames('bmc-modal--card relative', className)}
      isOpen={isOpen}
      onClose={onClose}
      header={false}
    >
      {isColourfulfunTemplate && (
        <>
          <div className="svg-modalFirstSvg" style={{ fill: firstSvgColor }}>
            <SvgIcon name="modalFirstSvg" />
          </div>
          <div className="svg-modalSecondSvg" style={{ fill: secondSvgColor }}>
            <SvgIcon name="modalSecondSvg" />
          </div>
        </>
      )}
      <div
        className="bmc-modal-content max-h-[90vh] overflow-y-auto"
        style={{ background: backgroundBMC }}
      >
        <div className="bmc-modal-card-header">
          <div className="bmc-modal-card-header-logo">
            <div
              className={`bmc-modal-card-header-logo-icon ${iconStyle} custom-font-body`}
              style={{ fill: iconFill, background: backgroundIcon }}
            >
              {typeof icon === 'string' ? <i className={icon} /> : icon}
            </div>
            <div
              className={`${titleStyle} custom-font-body`}
              style={{ color: titleColor }}
            >
              {title}
            </div>
          </div>
          {!isPreview ? (
            <div className="bmc-modal-card-header-actions">
              <Button
                className={`${buttonStyle} mr-2`}
                onClick={() => history.push(to)}
              >
                {canvas.openSection}
              </Button>
              <Button variant="ghost" onClick={onClose}>
                <X className="w-5 h-auto text-primary-text" />
              </Button>
            </div>
          ) : (
            <div className="bmc-modal-card-header-actions">
              <Button
                className="close-modal-button"
                onClick={onClose}
                style={{ fill: iconFillClose || backgroundButton }}
              >
                <SvgIcon name="closePortfolioModalIcon" />
              </Button>
            </div>
          )}
        </div>

        {children}
      </div>
    </Modal>
  );
}
